// Shared public-facing constants.

// Fallback for employees with no number of their own. 91 = India country code;
// wa.me rejects a bare local number.
export const WHATSAPP_NUMBER = '919444285425';

// Reps enter their number however they like — "98765 43210", "+91 98765-43210",
// "09876543210". wa.me accepts digits only, with a country code and no leading
// zero, so normalise here rather than trusting what was typed into the CRM.
export function waNumber(raw) {
  const digits = String(raw || '').replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return WHATSAPP_NUMBER;
  return digits.length <= 10 ? `91${digits}` : digits;
}
